<template>
  <base-dialog
  v-model="model"
  :width="800"
  header-bg="blue"
  :title="$t('dialogs.titles.whichTypesDoesPartSupport')">
    <predefined-services-by-type-lists
    v-model="servicesForDiagnosticsProp"
    :all-available="availablePredefinedServicesForDiagnostics"
    title="headers.diagnosticTypes"
    :loading="loading"/>

    <predefined-services-by-type-lists
    v-model="servicesForRepairProp"
    :all-available="availablePredefinedServicesForRepair"
    title="headers.repairTypes"
    :loading="loading"/>
    
    <predefined-services-by-type-lists
    v-model="servicesForPartsProp"
    :all-available="availablePredefinedServicesForParts"
    title="headers.partsUsed"
    :loading="loading"
    :show-footer-line="false"/>

    <div
    class="d-flex justify-center my-4">
      <primary-btn
      :label="$t('save')"
      @click="tryToSave"
      color="#4285f4"
      :loading="loading"
      :disabled="loading"
      :width="100"
      :height="40"/>
    </div>
  </base-dialog>
</template>
<script>
import BaseDialog from '@/components/dialogs/BaseDialog'
import { execHttpRequestThrowable } from '@/services/http'
import { getAllAvailablePredefinedServicesByServiceType, savePredefinedServicesToPart } from '@/repositories/partRepo'
import PrimaryBtn from '@/components/btns/PrimaryBtn'
import PredefinedServicesByTypeLists from '@/components/dialogs/shared/PredefinedServicesByTypeLists'
export default {
  components: {
    PrimaryBtn,
    BaseDialog,
    PredefinedServicesByTypeLists
  },
  props: {
    value: Boolean,
    servicesForDiagnostics: {
      type: Array,
      default: () => []
    },
    servicesForRepair: {
      type: Array,
      default: () => []
    },
    servicesForParts: {
      type: Array,
      default: () => []
    },
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  data() {
    return {
      loading: false,
      availablePredefinedServicesForDiagnostics: [],
      availablePredefinedServicesForRepair: [],
      availablePredefinedServicesForParts: []
    }
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    },
    servicesForDiagnosticsProp: {
      get: function() {
        return this.$props.servicesForDiagnostics
      },
      set: function(v) {
        this.$emit('update:servicesForDiagnostics', v)
      }
    },
    servicesForRepairProp: {
      get: function() {
        return this.$props.servicesForRepair
      },
      set: function(v) {
        this.$emit('update:servicesForRepair', v)
      }
    },
    servicesForPartsProp: {
      get: function() {
        return this.$props.servicesForParts
      },
      set: function(v) {
        this.$emit('update:servicesForParts', v)
      }
    }
  },
  methods: {
    closeDialog() {
      this.model = false
    },
    async tryToSave() {
      const body = {
        DIAGNOSTICS: this.servicesForDiagnosticsProp,
        REPAIRS: this.servicesForRepairProp,
        PARTS: this.servicesForPartsProp
      }
      await execHttpRequestThrowable(async () => await savePredefinedServicesToPart(this.$route.params.id, body),
      {},
      v => this.loading = v)

      this.$snackbar.success("snackbar.success.predefinedServicesSaved")
      this.closeDialog()
    },
    async tryToFetchAllAvailablePredefinedServices() {
      const r = await execHttpRequestThrowable(getAllAvailablePredefinedServicesByServiceType, {}, v => this.loading = v)
      const { DIAGNOSTICS, REPAIRS, PARTS } = r.response.data

      this.availablePredefinedServicesForDiagnostics = DIAGNOSTICS
      this.availablePredefinedServicesForRepair = REPAIRS
      this.availablePredefinedServicesForParts = PARTS
    }
  },
  mounted() {
    this.tryToFetchAllAvailablePredefinedServices()
  }
}
</script>
<style>
.predefined-services-list {
  border: 1px solid #d4d4d4;
  height: 400px;
  overflow-y: auto;
}
.predefined-services-list::-webkit-scrollbar {
  width: 5px;
}
.predefined-services-list::-webkit-scrollbar-thumb {
  background: radial-gradient(#ffffff60, #d4d4d4ea);
  border-radius: 0px;
}
.predefined-services-list::-webkit-scrollbar-track {
  background: #ffffff;
}
</style>